/* =Forms js
 ----------------------------------------------- */
(function ($) {

    // Supplier search pretty labels
    const customLabel = $('.supplier-search .categorychecklist label, .wpt-form-set-checkboxes label');
    const customInput = $('.supplier-search .categorychecklist input, .wpt-form-set-checkboxes input');
    const customLabelSearch = $('.supplier-search .categorychecklist label');
    const customLabelInputForm = $('.wpt-form-set-checkboxes label, .wpt-form-set-checkboxes input');

    if (customLabel.length > 0) {
        // Update checkboxes for search
        customLabelSearch.on('click keyup', function (e) {
            e.preventDefault();
            if (e.type === 'keyup' && e.keyCode !== 32) {
                return;
            }

            const customInputSearch = $(this).find('input');

            $(this).toggleClass('selected');
            customInputSearch.attr('checked', !customInputSearch.attr('checked'));
        });
        // Update checkboxed for forms (the toolkit plugin formats the two different for some reason)
        customLabelInputForm.on('click keyup', function (e) {
            e.preventDefault();
            if (e.type === 'keyup' && e.keyCode !== 32) {
                return;
            }

            const customInputForm = $(this).is('input') ? $(this) : $(this).prev('input');
            const customLabelForm = $(this).is('input') ? $(this).next('label') : $(this);

            customLabelForm.toggleClass('selected');

            customInputForm.attr('checked', !customInputForm.attr('checked'));
        });

        // Update pretty checkbox on load for search
        customLabel.find('input[checked]').parent().addClass('selected');
        // Add and remove focus state
        customInput.on('focus', function () {
            const labelFocus = $(this).parent().is('label') ? $(this).parent() : $(this).next('label');

            labelFocus.addClass('focus');
        });
        customInput.on('blur', function () {
            const labelBlur = $(this).parent().is('label') ? $(this).parent() : $(this).next('label');
            labelBlur.removeClass('focus');
        });
    }

    // Setup pretty selects
    const credForm = $('.cred-form');
    if (credForm.length > 0) {
        credForm.find('select').selectize();
    }

    // Scroll to results on load
    if (window.location.search.includes('wpv_post_search') || window.location.search.includes('wpv_sort_orderby') || window.location.search.includes('wpv-supplier-type')  || window.location.search.includes('wpv_paged')) {
        const heroImage = $('.hero-section');
        const supplierResults = $('.supplier-results');

        if (heroImage) {
            heroImage.imagesLoaded(() => {
                $('html, body').animate({
                    scrollTop: supplierResults.offset().top
                }, 500);
            });
        } else {
            $('html, body').animate({
                scrollTop: supplierResults.offset().top
            }, 500);
        }
    }

    // Limit the contents of a textarea
    const limitTextarea = $('.limit-textarea');
    if (limitTextarea.length) {
        const textareaLimit = 500;
        const textareaRemaining = limitTextarea.find('.limit-remaining');
        const textarea = limitTextarea.find('textarea');

        // Update remaining and limit on change
        textarea.on('keyup', function () {
            const textareaValue = $(this).val();
            const textareaLength = textareaValue.length;
            const displayLimit = (textareaLimit - textareaLength >= 0) ? textareaLimit - textareaLength : 0;

            textareaRemaining.html(displayLimit);

            if (textareaLength > textareaLimit) {
                textarea.val(textareaValue.substring(0, textareaLimit));
            }
        });

    }

})(jQuery);
